import React, { Dispatch, SetStateAction } from 'react';
import {
  View, Text, StyleSheet, Pressable,
} from 'react-native';
import Colors from '../constants/Colors';

interface TabSelectionMobileProps {
  options: any[],
  selectOption: Dispatch<SetStateAction<any>>,
  selectedOption: any,
  titles?: string[],
  disabled?: boolean,
}

const TabSelectionMobile = ({
  options, selectOption, selectedOption, titles = [], disabled = false,
}: TabSelectionMobileProps) => <View style={styles.container}>
    {options.map((option: any, index: number) => {
      const selected: boolean = option === selectedOption;
      return <Pressable
        onPress={() => selectOption(option)}
        style={[
          styles.button, selected ? styles.tabSelected : (disabled && styles.tabDisabled)]}
        key={`tab_option_${option}`}
        {...{ disabled }}
      >
        <Text style={[styles.title, selected && styles.titleSelected]}>
          {titles[index] ?? option}
        </Text>
      </Pressable>;
    })}
  </View>;

const styles = StyleSheet.create({
  container: {
    width: '100%',
    marginHorizontal: 24,
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: Colors.light.hereworksBlue100,
  },
  button: {
    borderBottomWidth: 4,
    borderBottomColor: 'transparent',
    paddingHorizontal: 12,
    paddingTop: 4,
    paddingBottom: 8,
    marginEnd: 8,
  },
  title: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlack500,
  },
  titleSelected: {
    color: Colors.light.hereworksBlue500,
  },
  tabSelected: {
    borderBottomColor: Colors.light.hereworksBlue500,
  },
  tabDisabled: {
    opacity: 0.2,
  },
});

export default TabSelectionMobile;
